// extracted by mini-css-extract-plugin
export default {"items":"AutoUploadModal__items--evBHh","text":"AutoUploadModal__text--1P-tO","modalTitle":"AutoUploadModal__modalTitle--3dCHl"};